
import AppSelectJournal from "../SelectJournal.vue";
import AppDiverseEditLedger from "./DiverseEditLedger.vue";
import AppDiverseEditLedgers from "./DiverseEditLedgers.vue";
import { DiverseLedger } from "@/models/base/diverse-ledger";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {Contact, Purchase, Sale} from "@/models/base";
import { printHumanFloat } from "@/utils/pretty-print";
import { DiverseLedgerService } from "@/services/diverse-ledgers-service";
import { BookYearService } from "@/services";
import AppContactSearch from "@/components/contacts/ContactSearch.vue";
import AppPurchaseSearch from "@/components/purchases/PurchaseSearchWithBrowse.vue";
import AppSaleSearch from "@/components/sales/SaleSearchWithBrowse.vue";

export default FormLike.extend({
	data(){
		return {
			isSaving: false,
			journalId: 1,
			date: new Date(),
			vatPeriod: 1,
			contact: null as null | Contact,
			invoice: null as null | Sale,
			purchase: null as null | Purchase,
			toEditLedger: new DiverseLedger(),
			ledgers: [] as DiverseLedger[],
			groupId: 1,
			isEditing: false
		};
	},
	props: {

	},
	watch: {
		"date": {
			immediate: true,
			handler(){
				if (!this.isEditing) {
					this.vatPeriod = BookYearService.getAccountingPeriodFromDate(this.date);
				}
			}
		}
	},
	computed: {
		isGenerated():boolean {
			return this.ledgers.some(l => l.isGenerated());
		},
		totalDebet():string {
			let total = 0;
			for (let ledger of this.ledgers) {
				total += ledger.Debet;
			}
			return printHumanFloat(total);
		},
		totalCredit():string {
			let total = 0;
			for (let ledger of this.ledgers) {
				total += ledger.Credit;
			}
			return printHumanFloat(total);
		},
		difference():boolean {
			let d=0, c=0;
			for (let ledger of this.ledgers) {
				d += ledger.Debet;
				c += ledger.Credit;
			}
			return d.toFixed(2) != c.toFixed(2);
		},
	},
	methods: {
		async onDate(date:Date){
			let oldDate = this.date;
			this.date = date;
			if (!BookYearService.isDateInBookYear(date, BookYearService.selectedBookYear)){
				let message = this.$ct("date-is-outside-bookyear-do-you-want-to-continue");
				let confirm = await this.$confirmBuilder(message).setWarningTitle().show();
				if (!confirm) {
					this.date = oldDate;
				}
			}
		},
		onSaleSelect(value:Sale){
			this.invoice = value;
			this.purchase = null;
		},
		onPurchaseSelect(value:Purchase){
			this.purchase =  value;
			this.invoice = null;
		},
		validate(){
			this.isValid = true;
			/*if (this.p.Ledgers.length == 0){
				this.isValid = false;
			}
			if (!this.p.doLedgersMatchTotal()) {
				this.isValid = false;
			}*/
		},
		cancel(){
			this.$emit("close");
		},
		async confirm(){
			//this.purchase.Ledgers = this.p.Ledgers.map(p=>new PurchaseLedger(p.getJSON()));
			//await this.askToSetDefaultLedgerInSupplier();
			this.isSaving = true;
			for (let ledger of this.ledgers){
				ledger.JournalID = this.journalId;
				ledger.Date = this.date;
				ledger.VatPeriod = this.vatPeriod;
				ledger.Contact = null;
				ledger.ContactID = 0;
				if (this.contact) {
					ledger.ContactID = this.contact.ID;
				}
				ledger.PurchaseID = 0;
				ledger.InvoiceID = 0;
				ledger.FriendlyPurchaseID = "";
				ledger.FriendlySaleID = "";
				ledger.GroupID = this.groupId;
				if (this.purchase) {
					ledger.FriendlyPurchaseID = this.purchase.ComputedFriendlyID;
					ledger.PurchaseID = this.purchase.ID;
				}else if (this.invoice) {
					ledger.InvoiceID = this.invoice.ID;
					ledger.FriendlySaleID = this.invoice.ComputedFriendlyID;
				}
			}
			if(this.difference){
				this.$wf.notify(this.$ct("warning").toString(), "danger", 3000, "check");
			}else{
				await DiverseLedgerService.saveLedgers(this.groupId, this.ledgers);
				this.$emit("refresh");
			}
			this.isSaving = false;
		},

		onInput(value:DiverseLedger){
			value.ContactID = this.toEditLedger.ContactID;
			value.VatPeriod = this.toEditLedger.VatPeriod;
			value.Date = this.toEditLedger.Date;
			value.JournalID = this.toEditLedger.JournalID;
			value.ID = this.toEditLedger.ID;
			let i = this.ledgers.indexOf(this.toEditLedger);
			if (i == -1) {
				this.ledgers.push(new DiverseLedger(value));
			}else{
				this.$set(this.ledgers, i, value);
			}
			this.setNewEmptyEditLedgerValue();
			this.validate();
		},
		setNewEmptyEditLedgerValue(){
			this.toEditLedger = new DiverseLedger();
			this.toEditLedger.BookYear = BookYearService.selectedBookYear;
		},
		getRemainingAmount():number {
			return 0;
			//return this.p.getSupposedLedgersTotal() - this.p.getLedgersTotal();
		},
		onItemSelected(value:DiverseLedger | null) {
			if (!value) {
				this.setNewEmptyEditLedgerValue();
				return;
			}
			this.toEditLedger = value;
		},
		removeLedger(){
			let i = this.ledgers.indexOf(this.toEditLedger);
			if (i == -1) return;
			this.ledgers.splice(i, 1);

			this.setNewEmptyEditLedgerValue();
			this.validate();
		},
	},
	async mounted(){
		this.setNewEmptyEditLedgerValue();
		this.validate();
		let id = parseInt(this.$route.params.id);
		if (id) {
			this.isEditing = true;
			let l = await DiverseLedgerService.get(id);
			this.toEditLedger = l;
			let g = await DiverseLedgerService.getByGroupID(l.GroupID);
			this.ledgers = g;
			if (this.ledgers.length > 0) {
				if (this.ledgers[0].InvoiceID != 0){
					this.invoice = this.ledgers[0].Invoice;
				}
				if (this.ledgers[0].PurchaseID != 0){
					this.purchase = this.ledgers[0].Purchase;
				}
				if (this.ledgers[0].ContactID != 0) {
					this.contact = this.ledgers[0].Contact;
				}
				this.date = this.ledgers[0].Date;
				this.journalId = this.ledgers[0].JournalID;
				this.vatPeriod = this.ledgers[0].VatPeriod;
				this.groupId = this.ledgers[0].GroupID;
			}
		}else{
			this.groupId = await DiverseLedgerService.getNextGroupID();
		}
	},

	components: {
		AppDiverseEditLedger,
		AppDiverseEditLedgers,
		AppSelectJournal,
		AppContactSearch,
		AppPurchaseSearch,
		AppSaleSearch
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
